export default "__VITE_ASSET__o$9$FxK9__"